import { InvoiceSyncErrorReason } from '../types';

export const INVOICE_SYNC_ERROR_REASON_I18N_KEYS: Record<InvoiceSyncErrorReason, string> = {
  [InvoiceSyncErrorReason.ProjectNotAvailable]: 'reason.projectNotAvailable',
  [InvoiceSyncErrorReason.CustomerNotAvailable]: 'reason.customerNotAvailable',
  [InvoiceSyncErrorReason.ProductOrServiceNotAvailable]: 'reason.productOrServiceNotAvailable',
  [InvoiceSyncErrorReason.CustomerCurrencyMismatch]: 'reason.customerCurrencyMismatch',
  [InvoiceSyncErrorReason.CurrencyNotEnabled]: 'reason.currencyNotEnabled',
  [InvoiceSyncErrorReason.AccountingPeriodClosed]: 'reason.accountingPeriodClosed',
  [InvoiceSyncErrorReason.NegativeLineAmountNotAllowed]: 'reason.negativeLineAmountNotAllowed',
  [InvoiceSyncErrorReason.LineDescriptionTooLong]: 'reason.lineDescriptionTooLong',
  [InvoiceSyncErrorReason.PaymentTermNotAvailable]: 'reason.paymentTermNotAvailable',
  [InvoiceSyncErrorReason.TransactionDateNotAllowed]: 'reason.transactionDateNotAllowed',
  [InvoiceSyncErrorReason.LineValueOutOfRange]: 'reason.lineValueOutOfRange',
  [InvoiceSyncErrorReason.DataRejected]: 'reason.dataRejected',
};
